import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CustomService } from 'src/app/services/custom.service';
import { FrontendService } from 'src/app/services/frontend.service';
import * as Global from 'src/app/global';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
    date: Date = new Date();

    footermenu = [
        { href: "our-services", label: "Our Services" },
        // { href: "how-we-work", label: "How We Work" },
        { href: "about-us", label: "About Us" },
        { href: "contact-us", label: "Contact Us" },
    ]
    pageLoading: boolean = true;
    siteSettings: any = null;
    social_links: any = [];
    constructor(
        private customService: CustomService,
        private frontendService: FrontendService,
        private formBuilder: FormBuilder,
        private toastr: ToastrService
    ) { }

    ngOnInit(): void {
        this.loadCms();
    }
    loadCms({
        loading = <boolean>true
    } = {}) {
        return new Promise((resolve, reject) => {
            if (loading) this.pageLoading = true;
            this.frontendService.loadCms({
                type: 'contactus'
            }).subscribe(res => {
                const data = res?.data;
                if (res.status == 'success') {
                    this.siteSettings = data?.site_settings ?? null;
                    this.social_links = data?.social_links ?? [];

                    resolve(true)
                } else {
                    this.customService.abortError(500, res?.message);
                    resolve(false)
                }

                if (loading) this.pageLoading = false;
            }, err => {
                this.customService.abortError(500, Global.getServerErrorMessage(err));
                if (loading) this.pageLoading = false;
                resolve(false)
            })
        })
    }

}
